import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

 const ExperiencecardsLoading = (props) => {

  const {
    count
  } = props;

  return <>
    {
      Array.apply(null, Array(count)).map((value, index) => <Grid key={index} item xs={12}>
        <ExperiencecardsLoading />
      </Grid>)
    }
  </>
}

ExperiencecardsLoading.propTypes = {
  count: PropTypes.number
}

ExperiencecardsLoading.defaultProps = {
  count: 1
}
export default ExperiencecardsLoading;